import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-supabase', 'BrandSupabase', [["path",{"d":"M4 14h8v7l8 -11h-8v-7l-8 11","key":"svg-0"}]]);